import axios, { Canceler } from 'axios'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  ICreateImpactTypeDto,
  IImpactTypesRespDto,
  IImpactTypeChangesRespDto,
  IMessageResponseDto,
  IUpdateImpactTypeDto,
} from 'src/types'

class ImpactTypeService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler
  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getImpactTypes(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }
    return this.get<IImpactTypesRespDto>('impact-types', {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  getImpactTypeChanges(id: string) {
    return this.get<IImpactTypeChangesRespDto>(`impact-types/${id}/changes`)
  }

  createImpactType(dto: ICreateImpactTypeDto) {
    return this.post<IMessageResponseDto, ICreateImpactTypeDto>('impact-types', dto)
  }

  updateImpactType({ id, ...dto }: IUpdateImpactTypeDto) {
    return this.put<IMessageResponseDto, Omit<IUpdateImpactTypeDto, 'id'>>(
      `impact-types/${id}`,
      dto,
    )
  }

  removeImpactTypes(ids: string[]) {
    return this.delete<IMessageResponseDto>(`impact-types`, { data: { ids } })
  }
}

export const impactTypeService = new ImpactTypeService()
export default ImpactTypeService
